var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    {
      staticClass: "billboard",
      attrs: { xs: _vm.xs, sm: _vm.sm, md: _vm.md, lg: _vm.lg, xl: _vm.xl },
    },
    [
      _c("div", { staticClass: "logo" }, [
        _vm.showDownloads
          ? _c("div", { staticClass: "downloads" }, [_c("app-downloads")], 1)
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }